module.exports = __webpack_public_path__ + "static/media/twitter-icon.f11912a7.png";